import { BulkAddFunds } from '../../pages';
import { payrollStore } from '../../stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { array, number, object, string } from 'yup';
import { amountFormatter } from '../../utils/utils';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { PayrollController } from '../../controllers';

const BulkAddFundsContainer = ({ closeModal }) => {
	const [method, setMethod] = useState(false);
	const [loading, setLoading] = useState(false);
	const [deduction, setDeduction] = useState(false);

	const selectMethod = () => {
		setMethod(true);
	};
	const addFundList = [
		'Bonus',
		'Overtime',
		'Time Off',
		'Retainer',
		'Welfare',
		'Severance',
		'Reimbursement',
		'SalaryAdvance',
		'Commission',
		'Others',
	];

	const validationSchema = () => {
		return object({
			payAdditions: array(
				object({
					amount: number()
						.min(1, 'Minimum amount is 1')
						.required('Amount is required'),
					type: string().required('Type is required'),
				})
			),
		});
	};
	const ids = JSON.parse(localStorage.getItem('Seleted IDs'));

	const onSubmit = async payload => {
		setLoading(true);
		payload = {
			payAdditions: payload.payAdditions.map(fund => {
				return { type: fund.type, amount: fund.amount };
			}),
			ids,
			type: 'addition'
		};
		const { status, errorMessage } = await PayrollController.bulkDeductionOrAddition(
			payload,
		);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: status,
			});
			setLoading(false);
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};
	const totalExtra = extra => {
		const totalAmount = extra.reduce(
			(previousValue, currentValue) => previousValue + currentValue.amount,
			0
		);
		return amountFormatter().format(totalAmount);
	};

	return (
		<BulkAddFunds
			closeModal={closeModal}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			totalExtra={totalExtra}
			idsCount = {ids?.length || 0}
			addFundList={addFundList}
			payrollSummaries={payrollStore.payrollSummaries}
			selectMethod={selectMethod}
			method={method}
			loading={loading}
		/>
	);
};

export default observer(BulkAddFundsContainer);
